export enum TenantEnum {
    US = 'us',
    EU = 'eu'    
}